import React from 'react';
import { RotateCw } from 'lucide-react';

export const QuestionCard = ({ question, index, onRegenerate }) => {
  return (
    <div className="eva-card" data-testid={`question-${index}`}>
      <div className="flex justify-between items-start mb-3">
        <div className="flex items-center gap-2">
          <p className="font-semibold text-white">Question {index + 1}</p>
          <span className="text-xs px-2 py-0.5 rounded-full font-medium bg-[#3B82F6]/10 text-[#3B82F6]">
            QCM
          </span>
        </div>
        <button
          onClick={() => onRegenerate(index)}
          className="text-sm text-[#3A506B] hover:text-white flex items-center gap-1"
          data-testid={`regenerate-question-${index}`}
        >
          <RotateCw size={14} />
          Régénérer
        </button>
      </div>

      <p className="text-slate-300 mb-4">{question.text}</p>

      {question.choices && question.choices.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-slate-400 uppercase tracking-wider font-semibold mb-2">
            Choix de réponse
          </p>
          <ul className="space-y-1">
            {question.choices.map((choice, i) => (
              <li key={`${question.id}-choice-${i}`} className={`text-sm flex items-start gap-2 ${
                choice.is_correct ? 'text-[#10B981]' : 'text-slate-300'
              }`}>
                <span className="mt-0.5">{choice.is_correct ? '✓' : '○'}</span>
                {choice.text}
              </li>
            ))}
          </ul>
        </div>
      )}

      {(!question.choices || question.choices.length === 0) && question.expected_answer && question.expected_answer.length > 0 && (
        <div className="mb-3">
          <p className="text-xs text-slate-400 uppercase tracking-wider font-semibold mb-2">
            Réponse attendue
          </p>
          <ul className="space-y-1">
            {question.expected_answer.map((answer, i) => (
              <li key={`${question.id}-answer-${i}`} className="text-sm text-slate-300 flex items-start gap-2">
                <span className="text-[#10B981] mt-0.5">✓</span>
                {answer}
              </li>
            ))}
          </ul>
        </div>
      )}

      {question.tags && question.tags.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {question.tags.map((tag, i) => (
            <span key={`${question.id}-tag-${i}`} className="px-2 py-1 bg-white/5 text-xs text-slate-400 rounded">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
